import Http from "../utils/Http";
import * as authActions from "../stores/actions/auth";

/**
 * Trade the link token for a destination. Public and always 200 — a dead link is
 * a state, not an error — so nothing is dispatched to the snackbar from here.
 */
export function resolveCashboxApprovalLink(token) {
  return () =>
    new Promise((resolve, reject) => {
      Http.get(`cashbox-approval/${token}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
}

/**
 * The approval card. Never 404s or 403s: "not for you" comes back as an empty
 * card, so a failure here is a real one and worth surfacing.
 */
export function fetchCashboxApproval(orderId) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get(`orders/${orderId}/cashbox-approval`)
        .then(res => resolve(res.data))
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

/** The comment is optional on approve and mandatory on reject; the API validates both. */
export function respondToCashboxApproval(orderId, is_approved, comment) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.post(
        `orders/${orderId}/cashbox-approval/${is_approved ? "approve" : "reject"}`,
        { comment }
      )
        .then(res => resolve(res.data))
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function fetchOfficeCashboxApproval(orderId) {
  return () =>
    new Promise((resolve, reject) => {
      Http.get(`office/orders/${orderId}/cashbox-approval`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
}

export function respondToOfficeCashboxApproval(orderId, is_approved, comment) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.post(
        `office/orders/${orderId}/cashbox-approval/${
          is_approved ? "approve" : "reject"
        }`,
        { comment }
      )
        .then(res => {
          dispatch(authActions.serverSuccess(res.data.meta.message));
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}
